import React, { useState } from "react";
import AddressPage from "./addressPage";
import PaymentPage from "./paymentPage";

export default function Checkout() {
  const [step, setStep] = useState("address"); 
  const [selectedAddress, setSelectedAddress] = useState("");

  return (
    <div className="p-3 md:p-8 xl:p-10 ">
      {step === "address" ? (
        <AddressPage
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          proceed={() => setStep("payment")}
        />
      ) : (
        <PaymentPage
          selectedAddress={selectedAddress}
          goBack={() => setStep("address")}
        />
      )}
    </div>
  );
}
